import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import { ArrowRight } from '@mui/icons-material';
import { Col, Row } from 'antd';
import { get, map } from 'lodash';
import PasswordRevealInline from 'components/PasswordRevealInline';
import { Accordion, AccordionSummary, AccordionDetails, AccordianTitle, Rotate } from './sharedStyles';

const ClassInfoCard = ({
    classes = [],
    title = "Active Classes",
    expandedId,
    onExpandChange,
    getClassId = (cls) => cls.id || cls.sectionId || cls.canvas_id || cls.googleId || cls.schoologyId || cls.classlinkid || cls.cleverId,
    getClassName = (cls) => cls.displayName || cls.name,
    getClassUsers = (cls) => cls.classUsers || cls.student || [],
    headerGradient = 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
    tableColumns = [],
    showStudentCount = true,
    colSpan = 12,
    colStyle = {}
}) => {
    if (!classes || classes.length === 0) return null;
    
    return (
        <Col span={colSpan} style={{paddingRight: "16px", ...colStyle}}>
            <div style={{
                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                borderRadius: '12px',
                padding: '16px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
                border: '1px solid #dee2e6'
            }}>
                <div style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#495057',
                    textAlign: 'center',
                    marginBottom: '16px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                }}>
                    {title}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {map(classes, cls => {
                        const classId = getClassId(cls);
                        const className = getClassName(cls);
                        const classUsers = getClassUsers(cls);
                        const isExpanded = expandedId == classId;
                        
                        return (
                            <div key={classId} style={{
                                background: '#fff',
                                borderRadius: '8px',
                                border: '1px solid #e9ecef',
                                overflow: 'hidden',
                                boxShadow: '0 2px 8px rgba(195, 47, 47, 0.04)'
                            }}>
                                <Accordion square expanded={isExpanded} onChange={onExpandChange(classId)}>
                                    <AccordionSummary 
                                        aria-controls="panel1d-content" 
                                        id="panel1d-header"
                                        style={{
                                            background: headerGradient,
                                            color: 'white',
                                            minHeight: '40px',
                                            '&:hover': {
                                                background: headerGradient
                                            }
                                        }}
                                    >
                                        <AccordianTitle style={{ color: 'white', fontWeight: '600', fontSize: '14px' }}>
                                            <span>
                                                {className} 
                                                {cls.archived ? <span style={{ color: '#ff6b6b' }}> (Archived)</span> : ''}
                                            </span>
                                            <div style={{ display:"flex", alignItems: 'center', gap: '6px' }}>
                                                {showStudentCount && (
                                                    <span style={{ 
                                                        background: 'rgba(255, 255, 255, 0.2)', 
                                                        padding: '2px 6px', 
                                                        borderRadius: '8px',
                                                        fontSize: '10px',
                                                        fontWeight: '600'
                                                    }}>
                                                        Students({classUsers.length})
                                                    </span>
                                                )}
                                                <Rotate open={isExpanded}>
                                                    <ArrowRight style={{ color: 'white' }} />
                                                </Rotate>
                                            </div>
                                        </AccordianTitle>
                                    </AccordionSummary>
                                    <AccordionDetails style={{ padding: '0' }}>
                                        <div style={{ padding: '12px' }}>
                                            <TableContainer>
                                                <Table style={{ width: "100%", textAlign: "center" }}>
                                                    <TableHead>
                                                        <TableRow style={{ background: '#f8f9fa' }}>
                                                            {tableColumns.map((col, idx) => (
                                                                <TableCell 
                                                                    key={idx}
                                                                    style={{ textAlign: "center", fontWeight: '600', color: '#495057' }}
                                                                >
                                                                    {col.label}
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {map(classUsers, (cuser, index) => {
                                                            return (
                                                                <TableRow key={index} style={{ '&:hover': { background: '#f8f9fa' } }}>
                                                                    {tableColumns.map((col, colIdx) => {
                                                                        const value = get(cuser, col.path, '');
                                                                        if (col.decodePassword) {
                                                                            return (
                                                                                <TableCell key={colIdx} style={{ textAlign: "center" }}>
                                                                                    <PasswordRevealInline userId={get(cuser, 'id')} username={get(cuser, 'username')} />
                                                                                </TableCell>
                                                                            );
                                                                        }
                                                                        let displayValue = value;
                                                                        if (col.formatValue && displayValue !== null && displayValue !== '') {
                                                                            displayValue = col.formatValue(displayValue);
                                                                        }
                                                                        const showTooltip = col.showTooltip && value && String(value).length > 5;
                                                                        
                                                                        return (
                                                                            <TableCell key={colIdx} style={{ textAlign: "center" }}>
                                                                                {showTooltip ? (
                                                                                    <Tooltip title={value} arrow placement="top">
                                                                                        <span style={{ cursor: 'help' }}>
                                                                                            {`${String(value).substring(0, 5)}...`}
                                                                                        </span>
                                                                                    </Tooltip>
                                                                                ) : (
                                                                                    displayValue !== null && displayValue !== '' ? displayValue : null
                                                                                )}
                                                                            </TableCell>
                                                                        );
                                                                    })}
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        );
                    })}
                </div>
            </div>
        </Col>
    );
};

export default ClassInfoCard;
